import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PrivateClassLesson } from '../private-class-lesson-dto';

@Component({
  selector: 'lp2-private-class-state-lesson-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <lp2-private-class-banner-container>
      <lp2-private-class-center-header-banner>
        <lp2-private-class-lesson-list
          class="grid-lesson-list flex-1"
          *ngIf="lessons"
          [canBeSelected]="true"
          [lessons]="lessons"
          [selectedLessonId]="selectedLessonId"
          (select)="onSelect($event)"
        ></lp2-private-class-lesson-list>
      </lp2-private-class-center-header-banner>
    </lp2-private-class-banner-container>
  `,
})
export class PrivateClassStateLessonSelectComponent {
  @Input() lessons: Array<PrivateClassLesson>;
  @Input() selectedLessonId: number;
  @Output() select = new EventEmitter<number>();

  public onSelect(lessonId: number) {
    this.select.emit(lessonId);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-states/private-class-state-lesson-select.component.ts